<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="warehouseRules"
    label='Warehouse'
    data-track="warehouse"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputWarehouse extends Vue {
  warehouseRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Warehouse is required'];
}
</script>
